import styled from 'styled-components';
import Page from 'components/Page';
import {device} from 'styled/device';

export const StyledPage = styled(Page)`
  padding-top: 74px;
  margin-top: 0;
  @media (min-width: ${device.tablet}) {
    padding: 0 64px 100px;
    margin: 24px auto 0;
  }
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
`;
